{
  "networks": {
    "mastercard": "Mastercard",
    "visa": "Visa",
    "discover": "Discover",
    "mne": "MNE"
  },
  "labels": {
    "payments": "Payments",
    "cash": "Cash",
    "pos": "POS",
    "path": "Path",
    "method": "Method",
    "scopes": "Scopes",
    "allowedScopes": "Allowed Scopes",
    "key": "Key",
    "code": "Code",
    "selectAll": "Select All",
    "transactionCurrency": "Transaction Currency",
    "note": "Note",
    "network": "Network",
    "merchant": "Merchant",
    "mccPadding": "MCC Padding",
    "billingCurrency": "Billing Currency",
    "billingAmount": "Billing Amount",
    "productDetails": "Product Details",
    "middleName": "Middle Name",
    "birthDate": "Date of Birth",
    "updateStatus": "Update Status",
    "certificateChain": "Certificate Chain",
    "applicationDetails": "Application Details",
    "transactionDetails": "Transaction Details",
    "referenceId": "Reference ID",
    "referenceNumber": "Reference Number",
    "transactionAmount": "Transaction Amount",
    "ledgerId": "Ledger ID",
    "more": "More",
    "selectPlaceholder": "Select or type",
    "select": "Select",
    "selectRegionPlaceholder": "Select Region",
    "selectReason": "Select Reason",
    "selectAccount": "Select Account",
    "selectChannel": "Select Channel",
    "lastUpdated": "Last updated:",
    "toggle": "toggle",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "compact": "Compact",
    "expanded": "Expanded",
    "address": "Address",
    "createdAt": "Created At",
    "createdBy": "Created By",
    "createdOn": "Created On",
    "updatedAt": "Updated At",
    "lastUpdatedBy": "Last Updated By",
    "lastUpdatedOn": "Last Updated On",
    "all": "All",
    "credit": "Credit",
    "debit": "Debit",
    "bucketId": "Bucket ID",
    "instrumentId": "Instrument ID",
    "bucketDescription": "Bucket Description",
    "currency": "Currency",
    "currencies": "Currencies",
    "selectCurrency": "Please select a currency",
    "primary": "Primary",
    "phone": "Phone",
    "workPhone": "Work Phone",
    "homePhone": "Home Phone",
    "mobile": "Mobile",
    "email": "Email",
    "emailAddress": "Email Address",
    "firstName": "First Name",
    "lastName": "Last Name",
    "nationalId": "National ID",
    "department": "Department",
    "authentication": "Authentication",
    "settings": "Settings",
    "client": "Client",
    "clientName": "Client Name",
    "clientDetails": "Client Details",
    "contactInformation": "Contact Information",
    "contactName": "Contact Name",
    "contactEmail": "Contact Email",
    "companyName": "Company Name",
    "fullName": "Full Name",
    "lastActiveAt": "Last Active",
    "primaryEmail": "Primary Email",
    "description": "Description",
    "mccLow": "MCC Low",
    "mccHigh": "MCC High",
    "currencyCode": "Currency Code",
    "currencyName": "Currency Name",
    "primaryAddress": "Primary Address",
    "otherAddress": "Other Address",
    "residentialAddress": "Residential Address",
    "mainAddress": "Main Address",
    "sameAsMainAddress": "Same as Main Address",
    "dispatchAddress": "Dispatch Address",
    "employerAddress": "Work/Employer Address",
    "warning": "Warning!",
    "no": "No",
    "yes": "Yes",
    "notAllowed": "Not Allowed",
    "allowed": "Allowed",
    "blocked": "Blocked",
    "status": "Status",
    "confirmation": "Confirmation",
    "search": "Search",
    "admin": "Admin",
    "summary": "Summary",
    "noDataAvailable": "No data available",
    "edit": "Edit",
    "value": "Value",
    "setting": "Setting",
    "virtual": "Virtual",
    "physical": "Physical",
    "details": "Details",
    "instruments": "Instruments",
    "placeholder": "Enter value",
    "fieldRequired": "This field is required",
    "enterValidPhone": "Please enter a valid phone number",
    "positiveNumberField": "This field must be a positive number",
    "productId": "Product ID",
    "cardProgramId": "Card Program ID",
    "customerId": "Customer ID",
    "basicInfo": "Basic information",
    "contactDetails": "Contact Details",
    "customerDetails": "Customer Details",
    "otherDetails": "Other Details",
    "customerType": "Customer Type",
    "type": "Type",
    "actions": "Actions",
    "customers": "Customers",
    "financialProducts": "Financial Products",
    "instrumentProducts": "Instrument Products",
    "keyManagement": "Key Management",
    "nameLabel": "Name",
    "notes": "Notes",
    "emailInvalid": "Please enter a valid email address",
    "emailRequired": "Please enter your email address",
    "productCode": "Product Code",
    "productDescription": "Product Description",
    "productName": "Product Name",
    "subClients": "Sub Clients",
    "view": "View",
    "frequency": "Frequency",
    "card": "Card",
    "cardType": "Card Type",
    "copy": "Copy",
    "copyToClipboardSuccess": "Copied to clipboard",
    "product": "Product",
    "total": "Total",
    "optional": "Optional",
    "items": "items",
    "quickActions": "Quick Actions",
    "recentActivity": "Recent Activity",
    "last24Hours": "Last 24 Hours",
    "attention": "Attention Required",
    "statusChange": "Status Change",
    "configUpdate": "Configuration Update",
    "access": "Access",
    "pin": "Pin",
    "configuration": "Configuration",
    "sequenceNumber": "Sequence No.",
    "title": "Title",
    "role": "Job role",
    "limits": "Limits",
    "reviewSubmit": "Review & Submit",
    "of": "of",
    "atmWithdrawal": "ATM Withdrawal",
    "posMerchant": "POS Merchant",
    "onlineEcommerce": "Online/E-Commerce",
    "contactless": "Contactless",
    "usage": "Usage",
    "fees": "Fees",
    "tokens": "Tokens",
    "services": "Services",
    "transactions": "Transactions",
    "statement": "Statement",
    "dueDate": "Due Date",
    "scope": "Scope",
    "category": "Category",
    "start": "Start",
    "stop": "Stop",
    "chooseDeliveryAddress": "Choose Delivery Address",
    "usageSettings": "Usage Settings",
    "timestamp": "Timestamp",
    "message": "Message",
    "user": "User",
    "users": "Users",
    "action": "Action",
    "ipAddress": "IP Address",
    "system": "System",
    "basicInformation": "Basic Information",
    "id": "ID",
    "clientId": "Client ID",
    "reviewAndFinish": "Review And Finish",
    "reviewAndFinishMSAClient": "Review And Create Client",
    "reviewAndFinishSubClient": "Review And Create Sub Client",
    "groupName": "Group Name",
    "groupAssigned": "Group",
    "customerRole": "Customer Role",
    "content": "Content",
    "transactionType": "Transaction Type",
    "customerName": "Customer Name",
    "instrument": "Instrument",
    "recordId": "Record ID",
    "transactionSummary": "Transaction Summary",
    "transactionDate": "Transaction Date",
    "noRelatedResult": "No related result",
    "review": "Review",
    "ledger": "Ledger",
    "ledgers": "Ledgers",
    "ledgerName": "Ledger Name",
    "ledgerDetails": "Ledger Details",
    "addLedger": "Add Ledger",
    "createNewLedger": "Create New Ledger",
    "ledgerCreatedSuccess": "Ledger created successfully",
    "date": "Date",
    "region": "Region",
    "channel": "Channel",
    "showMore": "Show More",
    "selectDate": "Select Date",
    "notProvided": "Not provided",
    "productType": "Product Type",
    "processingCode": "Processing Code",
    "balance": "Balance",
    "lastUsed": "Last used",
    "count": "Count",
    "standard": "Standard",
    "clientAssignedId": "Client Assigned ID",
    "clientAssignedIdPlaceholder": "Enter client assigned ID",
    "accountHolderType": {
      "label": "Account Holder Type",
      "placeholder": "Select account holder type",
      "individual": "Individual",
      "commercial": "Commercial"
    },
    "customerTitle": {
      "mr": "Mr",
      "ms": "Ms",
      "mrs": "Mrs",
      "placeholder": "Select title"
    },
    "dateOfBirth": {
      "day": "Day",
      "dayPlaceholder": "DD",
      "month": "Month",
      "monthPlaceholder": "MM",
      "year": "Year",
      "yearPlaceholder": "YYYY"
    },
    "percentage": "Percentage",
    "offsetAccountType": "Offset Account Type",
    "offsetLedgerPositionLoadErrorTitle": "Could not load position",
    "offsetLedgerPositionEmptyForDate": "No position was returned for the selected date.",
    "offsetLedgerPositionSkippedNoChannel": "End-of-day position cannot be loaded because this offset account is not linked to a channel.",
    "opening": "Opening",
    "closing": "Closing",
    "learnMore": "Learn More",
    "transactionId": "Transaction ID",
    "transactionDateAndTime": "Transaction Date & Time",
    "entryType": "Entry Type",
    "totalOpeningBalance": "Total Opening Balance",
    "totalClosingBalance": "Total Closing Balance",
    "currentBalance": "Current Balance",
    "change": "Change",
    "totalDebits": "Total Debits",
    "totalCredits": "Total Credits",
    "reasonCode": "Reason Code",
    "from": "From",
    "to": "To",
    "amount": "Amount",
    "internal": "Internal",
    "other": "Other",
    "withdraw": "Withdraw",
    "reason": "Reason",
    "goBack": "Go Back",
    "refund": "Refund",
    "correction": "Correction",
    "payroll": "Payroll",
    "supplier": "Supplier",
    "actualBalance": "Actual Balance",
    "adjustmentType": "Adjustment Type",
    "availableBalance": "Available Balance",
    "balanceAdjustment": "Balance Adjustment",
    "cardDetails": "Card Details",
    "noResultsFound": "No results found",
    "publicToken": "Public Token",
    "required": "Required",
    "reviewAndSave": "Review & Save",
    "transactionTypes": {
      "FEE": "Fee",
      "LOAD": "Load",
      "UNLOAD": "Unload"
    },
    "none": "None",
    "startDate": "Start Date",
    "machineName": "Machine Name",
    "screenName": "Screen Name",
    "apexCard": "Apex Product ID",
    "accountHolderId": "Account Holder ID",
    "accountId": "Account ID",
    "subClientId": "Sub Client ID",
    "dailyLimit": "Daily Limit",
    "overview": "Overview",
    "accountName": "Account Name",
    "currencyType": "Currency Type",
    "transactionNote": "Transaction Note",
    "masterVirtual": "Master Virtual",
    "seeMore": "see more..."
  },
  "components": {
    "accountHolder": {
      "addButton": "Add Customer",
      "messages": {
        "createSuccess": "Customer created successfully"
      }
    },
    "badge": {
      "new": "New"
    },
    "buttons": {
      "save": "Save",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "back": "Back",
      "submit": "Submit",
      "retry": "Retry",
      "delete": "Delete",
      "yesDelete": "Yes, Delete",
      "addNewFields": "Add new fields",
      "next": "Next",
      "previous": "Previous",
      "previousStep": "Previous Step",
      "reviewAndSave": "Review and Save",
      "edit": "$t(common:labels.edit)",
      "details": "$t(common:labels.details)",
      "actions": "$t(common:labels.actions)",
      "confirmChanges": "Confirm Changes",
      "confirmChangesTo": "Confirm changes to {{title}}",
      "changesTo": "Changes to",
      "create": "Create",
      "addNew": "Add New",
      "add": "Add",
      "filter": "Filter",
      "addFilter": "Add Filter",
      "resetAll": "Reset All",
      "refresh": "Refresh",
      "viewAll": "View All",
      "viewAllActivity": "View All Activity",
      "ok": "Ok",
      "reset": "Reset",
      "go": "Go",
      "proceed": "Proceed",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "saveChanges": "Save Changes",
      "update": "Update",
      "close": "Close",
      "saveAndContinue": "Save and continue",
      "confirmLimit": "Confirm Limit",
      "applyFilters": "Apply Filters",
      "apply": "Apply",
      "sendMoney": "Send money",
      "backToEdit": "Back to Edit",
      "clearSearch": "Clear",
      "download": "Download",
      "skip": "Skip",
      "finish": "Finish",
      "remove": "Remove"
    },
    "card": {
      "pan": "PAN",
      "form": "Form",
      "expires": "Expires",
      "scheme": "Scheme",
      "rdsSchemeId": "RDS Scheme Id",
      "thirdpartyId": "Third Party Id",
      "expiryDate": "Expiry Date",
      "embossedName": "Embossed Name"
    },
    "transactionDetailsHeader": {
      "iconsMapper": {
        "cardUnload": "Card Unload",
        "cardLoad": "Card Load"
      }
    },
    "mainMenu": {
      "customers": "$t(common:labels.customers)",
      "allClients": "All Clients",
      "allSubClients": "All Sub-Clients",
      "clients": "Clients",
      "msaClients": "MSA Clients",
      "subClients": "$t(common:labels.subClients)",
      "products": "Products",
      "services": "$t(common:labels.services)",
      "financialProducts": "$t(common:labels.financialProducts)",
      "instrumentProducts": "$t(common:labels.instrumentProducts)",
      "keyManagement": "$t(common:labels.keyManagement)",
      "admin": "$t(common:labels.admin)",
      "demoHub": "Demo Hub",
      "configuration": "$t(common:labels.configuration)",
      "customerDashboard": "Customer Dashboard",
      "storefront": "Storefront",
      "referenceData": "Reference Data",
      "featureFlags": "Feature Flags",
      "ledgerSimulation": "Ledger Simulation",
      "badgerBank": "Badger Bank",
      "finance": "Finance",
      "treasury": "Treasury",
      "offsetAccounts": "Offset Accounts",
      "ssoConfiguration": "SSO Configuration",
      "applications": "Applications",
      "userManagement": "User Management",
      "systemAdmin": "System Admin",
      "ehiConfiguration": "EHI Configurations",
      "sandbox": "Sandbox",
      "domainLists": "Domain Lists",
      "accounts": "Accounts"
    },
    "notFound": {
      "title": "Page not found",
      "description": "Sorry, the page you visited does not exist.",
      "backToHome": "Back to Home",
      "network": "Network error",
      "networkDescription": "Please check your internet connection and try again."
    },
    "userMenu": {
      "documentationPortal": "Documentation",
      "signOut": "Sign out",
      "switchToThreddPortal": "Switch to Thredd Portal",
      "signOutError": "Oops! Failed to sign out",
      "signOutErrorDescription": "We have failed to sign you out of your account. Please try again.",
      "featureRequest": "Feature request"
    },
    "reviewAndFinish": {
      "description": "Take a moment to double-check your details before saving or exiting. Make sure everything looks good - you can still make edits if needed."
    },
    "clientScoping": {
      "configureClient": "Configure Client",
      "typeSubClient": "Sub-Client",
      "selectClient": "Select Client",
      "selectSubClient": "Select Sub-Client",
      "selectClientDescription": "Select the client you want to manage.",
      "selectSubClientDescription": "Select the sub-client you want to work with.",
      "configureAsDefault": "Configure as default",
      "backToClients": "Back to Clients",
      "successDescription": "Your {{type}} is selected.",
      "searchPlaceholder": "Search by name or ID"
    },
    "navigationWarning": {
      "title": "Unsaved Changes",
      "description": "Are you sure you want to leave this page? Any unsaved changes may be lost.",
      "confirm": "Yes, proceed",
      "discard": "Discard",
      "cancel": "No, cancel"
    },
    "draftWarning": {
      "description": "Do you want to save these changes as draft?",
      "save": "Save as draft"
    },
    "featureRequest": {
      "title": "Feature Requests",
      "subtitle": "Create a feature request by entering a criteria",
      "namePlaceholder": "Enter your name",
      "nameRequired": "Please enter your name",
      "emailPlaceholder": "Enter your email address",
      "problemLabel": "Problem",
      "problemPlaceholder": "Describe the problem you want to solve",
      "problemRequired": "Please describe the problem you want to solve",
      "descriptionLabel": "Description of the feature",
      "descriptionPlaceholder": "Describe the feature you would like to request",
      "priorityLabel": "Priority Level",
      "priorityPlaceholder": "Select priority",
      "priorityMinor": "Minor",
      "priorityMajor": "Major",
      "priorityCritical": "Critical",
      "priorityRequired": "Please select a priority",
      "submit": "Submit Request",
      "successTitle": "Request Submitted",
      "successDescription": "Thank you for your feedback. Your feature request has been submitted successfully.",
      "errorTitle": "Error Submitting",
      "errorDescription": "There was a problem submitting your feature request. Please try again later.",
      "note": "Please complete all mandatory fields before submitting request."
    },
    "feedbackWidget": {
      "launcher": {
        "label": "Share Feedback"
      },
      "modal": {
        "title": "Help us improve",
        "closeButtonAriaLabel": "Close feedback dialog"
      },
      "sentiment": {
        "needsWork": "Needs Work",
        "okay": "It is Okay",
        "satisfied": "Satisfied"
      },
      "rating": {
        "prompt": "Please rate the following:"
      },
      "comment": {
        "needsWorkLabel": "How can we improve?",
        "okayLabel": "Anything else you'd like to share?",
        "satisfiedLabel": "What did you like most?",
        "optional": "(optional)"
      },
      "submit": {
        "label": "Submit Feedback"
      },
      "toast": {
        "message": "Thank you for your feedback"
      },
      "error": {
        "submitFailed": "Something went wrong. Please try again."
      }
    },
    "noRoleAssigned": {
      "title": "No Role Assigned",
      "description": "You do not have a role assigned to you.",
      "callToAction": "Please contact your administrator to be assigned a role."
    },
    "insufficientPermissions": {
      "title": "Insufficient Permissions",
      "description": "Your account does not have the required permissions to access this application.",
      "callToAction": "Please contact your account manager."
    },
    "onlineStatus": {
      "offlineMessage": "You are offline",
      "offlineDescription": "Your internet connection has been lost. Some features may be unavailable.",
      "onlineMessage": "You are back online",
      "onlineDescription": "Your internet connection has been restored."
    },
    "addressFields": {
      "city": "City",
      "state": "State/Province",
      "postalCode": "Postal Code",
      "postCodeWithParam": "Postcode: {{postalCode}}",
      "addressLine1": "Address Line 1",
      "addressLine2": "Address Line 2",
      "houseNumber": "House Number",
      "country": "Country",
      "selectACountry": "Please select a country"
    },
    "auditLog": {
      "title": "Audit Log",
      "fromDate": "From Date",
      "toDate": "To Date",
      "section": "Section",
      "export": "Export",
      "exportAll": "Export All",
      "recentActivityLog": "Recent Activity Logs",
      "showResults": "Show results"
    },
    "dataTable": {
      "custom": "Custom",
      "defaultSettings": "Default Settings",
      "buttons": {
        "customizeColumns": "Columns",
        "resetFilters": "Reset Filters"
      },
      "columnsOrderModal": {
        "title": "Columns Customization",
        "description": "Reorder columns by dragging and dropping them to your desired position. You can also toggle columns visibility to customise your view."
      }
    },
    "featureFlags": {
      "errors": {
        "onlyNumbers": "Please enter a valid integer"
      },
      "subtitle": "Current UI feature flags configured for this environment.",
      "searchPlaceholder": "Search by flag name or description",
      "featureKey": "Feature flag key"
    },
    "sandboxAdmin": {
      "userManagement": {
        "title": "Sandbox Users",
        "subtitle": "Manage users registered on the sandbox environment.",
        "verifiedEmail": "Verified Email",
        "activated": "User activated",
        "deactivated": "User deactivated",
        "deactivateTitle": "Deactivate user",
        "deactivateContent": "Are you sure you want to deactivate {{name}}? They will no longer be able to access the sandbox.",
        "updateFailed": "Failed to update user status",
        "searchPlaceholder": "Search by full name, email, company or title"
      },
      "auditLog": {
        "title": "Sandbox Audit Log",
        "subtitle": "Requests sent to the sandbox environment.",
        "duration": "Duration",
        "selectUserPlaceholder": "Select a user",
        "noUserSelected": "Select a user to view their request logs"
      },
      "domainLists": {
        "title": "Sandbox Domain Lists",
        "subtitle": "Manage email domains allowed or blocked for sandbox signup.",
        "allowTab": "Allow list",
        "blockTab": "Block list",
        "allowListTitle": "Allowed domains",
        "blockListTitle": "Blocked domains",
        "addDomain": "Add domain",
        "domainLabel": "Domain",
        "addTitle": "Add domain to the {{list}}",
        "addPlaceholder": "e.g. example.com",
        "invalidDomain": "Enter a valid domain, e.g. example.com",
        "alreadyInList": "This domain is already on the {{list}}.",
        "conflictWarning": "This domain is also on the {{otherList}}. Block list entries take precedence over the allow list.",
        "alsoBlocked": "Also blocked",
        "alsoAllowed": "Also allowed",
        "removeConfirmTitle": "Remove domain",
        "removeConfirmContent": "Remove {{domain}} from the {{list}}?",
        "addedSuccess": "Domain added",
        "addedSuccessDescription": "{{domain}} added to the {{list}}.",
        "removedSuccess": "Domain removed",
        "removedSuccessDescription": "{{domain}} removed from the {{list}}.",
        "addFailed": "Failed to add domain",
        "removeFailed": "Failed to remove domain",
        "searchPlaceholder": "Search domains",
        "empty": "No domains in this list"
      }
    }
  },
  "status": {
    "revoked": "Revoked",
    "open": "Open",
    "closed": "Closed",
    "closureScheduled": "Closure Scheduled",
    "statusUnspecified": "Status Unspecified",
    "processing": "$t(status.live)",
    "live": "Live",
    "awaitingApproval": "Awaiting Approval",
    "approved": "Approved",
    "suspended": "Suspended",
    "draft": "Draft",
    "loading": "Loading...",
    "success": "Success",
    "error": "Error",
    "errorLoadingContactlessSettings": "Error loading contactless settings.",
    "available": "Available",
    "unknown": "Unknown",
    "active": "Active",
    "inactive": "Inactive",
    "frozen": "Frozen",
    "settled": "Settled",
    "pending": "Pending",
    "unspecified": "Unspecified",
    "rejected": "Rejected",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "daily": "daily",
    "weekly": "weekly",
    "monthly": "monthly",
    "yearly": "yearly",
    "information": "Information",
    "complete": "Complete",
    "incomplete": "Incomplete",
    "maintenance": "Maintenance",
    "unhealthy": "Unhealthy",
    "scaleUp": "Scaling Up",
    "latest": "Latest",
    "outdated": "Outdated",
    "updating": "Updating",
    "deceased": "Deceased",
    "stale": "Stale",
    "requiresAttention": "Requires Attention",
    "inProgress": "In Progress",
    "permanentStatusWarning": "This status is permanent and cannot be changed once applied.",
    "currentStatus": "Current Status"
  },
  "errors": {
    "unknown": "Unknown Error",
    "generic": "An error occurred.",
    "validation": "Validation Error",
    "missingId": "Missing ID",
    "requestFailed": "Request Failed",
    "pleaseTryAgainLater": "Something went wrong. Please try again later.",
    "unauthorized": "Unauthorised. Please log in again.",
    "permission": "You don't have permission to perform this action.",
    "requestedResourceNotFOund": "The requested resource could not be found.",
    "unexpectedWithStatus": "Unexpected error (status {{status}})"
  },
  "confirmations": {
    "saveChanges": "Are you sure you want to save these changes?",
    "noChanges": "No changes were made.",
    "addEntity": {
      "messageSuccess": "Successfully added",
      "descriptionSuccess": "The '{{entity}}' has been successfully created",
      "messageDeletionFailed": "Creation failed",
      "confirmationText": "Are you sure you want to create the '{{name}}' {{type}}?"
    },
    "deleteEntity": {
      "messageSuccess": "Successfully deleted",
      "descriptionSuccess": "The {{name}} {{entity}} has been successfully deleted",
      "messageDeletionFailed": "Deletion failed",
      "confirmationText": "Are you sure you want to delete the '{{name}}' {{type}}?"
    },
    "updateEntity": {
      "updateStarted": "Update started",
      "messageSuccess": "Successfully updated",
      "descriptionSuccess": "The {{name}} {{entity}} update has started",
      "messageUpdateFailed": "Update failed",
      "confirmationText": "Are you sure you want to {{action}} {{entity}}?",
      "confirmationTextUpdateBuild": "Are you sure you want to update the '{{name}}' connection to the latest build?"
    },
    "deleteGroup": {
      "messageSuccess": "Successfully deleted group",
      "descriptionSuccess": "The group '{{groupName}}' has been successfully deleted",
      "messageDeletionFailed": "Group deletion failed",
      "confirmationText": "Are you sure you want to delete the group '{{groupName}}'?"
    },
    "updateGroup": {
      "messageSuccess": "Successfully updated group",
      "descriptionSuccess": "Updates have started for group: '{{groupName}}'.",
      "messageUpdateFailed": "Group update failed",
      "confirmationText": "Are you sure you want to update the group '{{groupName}}'?"
    },
    "createGroup": {
      "messageSuccess": "Successfully created group",
      "descriptionSuccess": "The group '{{groupName}}' has been successfully created",
      "messageCreationFailed": "Group creation failed",
      "confirmationText": "Are you sure you want to create the group '{{groupName}}'?"
    },
    "addToGroup": {
      "messageSuccess": "Successfully added to group",
      "descriptionSuccess": "The connection has been successfully added to the group '{{groupName}}'",
      "messageAdditionFailed": "Addition to group failed",
      "confirmationText": "Are you sure you want to add this connection to the group '{{groupName}}'?"
    },
    "removeFromGroup": {
      "messageSuccess": "Successfully removed from group",
      "descriptionSuccess": "The connection has been successfully removed from the group '{{groupName}}'",
      "messageRemovalFailed": "Removal from group failed",
      "confirmationText": "Are you sure you want to remove this connection {{connectionName}} from the group '{{groupName}}'?"
    },
    "updateGroupedServices": {
      "messageSuccess": "Successfully updated services",
      "descriptionSuccess": "The services for group '{{groupName}}' have been successfully updated",
      "descriptionUpdateStarted": "The services for group '{{groupName}}' update has started",
      "messageUpdateFailed": "Services update failed",
      "descriptionUpdateFailed": "The services for group '{{groupName}}' update has failed",
      "updateFailedToStart": "Failed to start update",
      "descriptionUpdateFailedToStart": "The services for group '{{groupName}}' update has failed to start",
      "confirmationText": "Are you sure you want to update the services for the group '{{groupName}}'?"
    },
    "discardChanges": {
      "confirmationText": "Are you sure? You changes will be discarded."
    }
  },
  "spendLimits": {
    "minSpend": "Minimum Spend",
    "maxSpend": "Maximum Spend",
    "frequencyLimits": "Frequency Limits"
  },
  "modalTitles": {
    "confirmDelete": "Confirm Delete",
    "confirmUpdate": "Confirm Update",
    "addGroupModal": "Add Group",
    "editGroupModal": "$t(clientAccess:breadcrumbs.groups.edit)",
    "addToGroup": "Add to Group",
    "removeFromGroup": "Remove from Group",
    "filters": "Filters"
  },
  "creditLimits": {
    "creditCashLimit": "Credit Cash Limit",
    "maxCreditLimit": "Max Credit Limit",
    "validationMessages": {
      "enterValidMaxCashLimit": "Please enter valid cash limit",
      "enterValidMinimumPayment": "Please enter valid minimum payment"
    },
    "messages": {
      "noRecentActivity": "No recent activity"
    },
    "filters": {
      "filterByStatus": "Filter by status",
      "endDate": "End date",
      "clearFilters": "Clear Filters",
      "searchApplications": "Search applications...",
      "filterByNetwork": "Filter by network",
      "filterByNetworkConfiguration": "Filter by network configuration"
    }
  },
  "messages": {
    "unsavedChanges": "You have unsaved changes",
    "noCertificateReturned": "No certificate returned",
    "failedToDownloadCertificate": "Failed to download certificate",
    "downloadCertificateSuccess": "Certificate downloaded successfully"
  },
  "idpDiscovery": {
    "emailLabel": "Email address",
    "emailPlaceholder": "you@company.com",
    "continue": "Continue",
    "signingInAs": "Signing in as {{email}}",
    "useDifferentEmail": "Use a different email",
    "signInWithPassword": "Sign in with email & password",
    "chooseProvider": "Choose how you'd like to sign in",
    "signInWithCognito": "Sign in with Cognito",
    "signInWithCloudEntity": "Sign in with CloudEntity",
    "or": "or",
    "tryAnotherEmail": "Try another email",
    "noSsoProviders": "No SSO providers configured for this domain",
    "lookupFailed": "Failed to look up identity providers. Please try again.",
    "invalidEmail": "Invalid email address"
  },
  "passwordLogin": {
    "passwordLabel": "Password",
    "passwordRequired": "Password is required",
    "newPasswordLabel": "New password",
    "confirmPasswordLabel": "Confirm new password",
    "passwordsDoNotMatch": "Passwords do not match",
    "setPassword": "Set password and sign in",
    "signIn": "Sign in",
    "mfaUnsupported": "Multi-factor authentication is not yet supported in the new login screen.",
    "orgSelection": {
      "prompt": "You belong to more than one organisation. Choose which one to sign into.",
      "error": "We couldn't sign you into that organisation. Please try again."
    },
    "forgotPassword": {
      "link": "Forgot your password?",
      "intro": "Enter your email and we'll send you a code to reset your password.",
      "sendCode": "Send reset code",
      "codeSent": "We sent a reset code to {{email}}. It may take a minute to arrive.",
      "codeLabel": "Reset code",
      "codeRequired": "Reset code is required",
      "resetPassword": "Reset password",
      "resendCode": "Didn't get a code? Send another",
      "backToSignIn": "Back to sign in",
      "successInfo": "Your password has been reset. Sign in with your new password."
    },
    "errors": {
      "invalidCredentials": "Incorrect email or password.",
      "userNotFound": "We couldn't find an account for that email.",
      "passwordResetRequired": "A password reset is required for this account.",
      "userNotConfirmed": "This account has not been confirmed yet.",
      "codeMismatch": "That reset code is incorrect. Please check and try again.",
      "codeExpired": "That reset code has expired. Request a new one.",
      "invalidPassword": "That password doesn't meet the requirements. Try a longer or more complex one.",
      "tooManyRequests": "Too many attempts. Please try again in a few minutes."
    }
  }
}
